// extracted by mini-css-extract-plugin
export var layoutContainer = "_8y-0";
export var layoutContainerNoRounding = "_8y-6";
export var layoutContainerOpen = "_8y-5";
export var layoutContainerResizing = "_8y-1";
export var mainContent = "_8y-2";
export var resizeDivider = "_8y-3";
export var slidePanel = "_8y-4";